import axios from 'axios';
import store from '../store/index.js';
import router from '../router';
import {
	Loading,
	Message
} from 'element-ui';

// 图片地址拼接
const BASEURL = 'https://clf.shgyht.com/';
// const BASEURL = 'http://192.168.2.110:7310/'
// 创建 axios 实例
const service = axios.create({
	// baseURL: '/api',
	baseURL: `https://clf.shgyht.com`,
	// baseURL: 'http://192.168.2.110:7310/',
	// timeout: 10000,
});

// 添加请求拦截器
service.interceptors.request.use(config => {
	// 获取 token
	const token = sessionStorage.getItem('token');
	if (token) {
		config.headers['Authorization'] = `Bearer ${token}`;
	}

	// 是否是 tab 切换
	const isTabChangeStr = sessionStorage.getItem('setIsTabChange');
	const isTabChange = isTabChangeStr === 'true';

	// 控制 loading
	const shouldShowLoading = !isTabChange;
	if (shouldShowLoading) {
		const loadingInstance = Loading.service({
			fullscreen: true,
			lock: true,
			text: '拼命加载中',
			spinner: 'el-icon-loading',
			background: 'rgba(0, 0, 0, 0.7)'
		});
		config.loadingInstance = loadingInstance;
	} else {
		// 是 tab 切换，尝试从缓存中取数据
		const routeName = router.currentRoute.path;
		const cachedData = JSON.parse(sessionStorage.getItem(routeName));

		const datalist = JSON.parse(sessionStorage.getItem(routeName + 'datalist'));


		console.log('荷载datalist：', datalist);
		if (cachedData) {
			console.log('路由名称：', router.currentRoute);
			// 在缓存数据中添加请求参数
			if (datalist) {
				cachedData.__requestPayload = datalist; // 把载荷挂到缓存数据上
			}
			// 有缓存，取消请求，直接返回缓存数据
			const source = axios.CancelToken.source();
			source.cancel({
				isCached: true,
				data: cachedData
			});
			config.cancelToken = source.token;

		} else {
			Message.warning('正在加载数据，请稍候...');
		}
		sessionStorage.setItem('setIsTabChange', 'false');
	}

	return config;
}, error => {
	return Promise.reject(error);
});

// 响应拦截器
service.interceptors.response.use(response => {
	// 关闭 loading
	if (response.config.loadingInstance) {
		response.config.loadingInstance.close();
	}

	// 处理 token 过期
	const {
		msg
	} = response.data;
	if (msg == 'Must have token' || msg == '令牌已过期,请从新登录') {
		Message.error(msg);
		router.push('/login');
		sessionStorage.clear();
		localStorage.clear();
	}

	// 非 tab 切换才缓存数据
	const isTabChangeStr = sessionStorage.getItem('setIsTabChange');
	const isTabChange = isTabChangeStr === 'true';

	const routeName = router.currentRoute.path;

	if (!isTabChange) {
		sessionStorage.setItem(routeName, JSON.stringify(response.data))

		if (response.config.data != undefined) {
			sessionStorage.setItem(routeName + 'datalist', response.config.data);
		} else {
			sessionStorage.setItem(routeName + 'datalist', {});
		}


	}
	sessionStorage.setItem('setIsTabChange', 'false'); // 重置标志位


	return response.data;

}, error => {
	if (error.config && error.config.loadingInstance) {
		error.config.loadingInstance.close();
	}

	// 处理缓存数据
	if (axios.isCancel(error)) {
		if (error.message && error.message.isCached) {
			return Promise.resolve(error.message.data);
		}
	}

	// 错误统一提示
	if (error.response) {
		Message.error(error.response.data.message || '服务器错误');
		if (error.response.status === 401) {
			router.push('/login');
			sessionStorage.clear();
			localStorage.clear();
		}
	} else if (error.request) {
		Message.error('请求超时，请稍后再试');
	} else {
		Message.error(error.message);
	}

	console.error('请求失败:', error);

	console.error('请求失败数据:', response.data);
	return Promise.reject(error);
});

export {
	BASEURL
};
export default service;